import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import useMyVendorRequestAccess from "../custom-hooks/useMyVendorRequestAccess";
import { runStatusDashboardViewDetails } from "./statusDashboardViewDetails";

/**
 * Status Dashboard View Details / row-open with VQQ↔VQA role lockdown.
 */
export default function useStatusDashboardViewDetails() {
  const navigate = useNavigate();
  const { canRequestVqq, canRequestVqa } = useMyVendorRequestAccess();
  const [accessNotice, setAccessNotice] = useState({
    open: false,
    message: "",
  });

  const showLocked = useCallback((message) => {
    setAccessNotice({ open: true, message });
  }, []);

  const openVqqDetails = useCallback(
    (vqqId) => {
      runStatusDashboardViewDetails(
        "VQQ",
        {
          canOpenVqq: canRequestVqq,
          canOpenVqa: canRequestVqa,
          vqqId,
        },
        { navigate, onLocked: showLocked }
      );
    },
    [canRequestVqa, canRequestVqq, navigate, showLocked]
  );

  const openVqaDetails = useCallback(
    (vqaId) => {
      runStatusDashboardViewDetails(
        "VQA",
        {
          canOpenVqq: canRequestVqq,
          canOpenVqa: canRequestVqa,
          vqaId,
        },
        { navigate, onLocked: showLocked }
      );
    },
    [canRequestVqa, canRequestVqq, navigate, showLocked]
  );

  const closeAccessNotice = useCallback(() => {
    setAccessNotice({ open: false, message: "" });
  }, []);

  return {
    openVqqDetails,
    openVqaDetails,
    accessNotice,
    closeAccessNotice,
  };
}
